module.exports = __webpack_public_path__ + "img/MilitaryTechBackgroundC01_ua.9e04b205.webp";